import React, { useEffect, useState } from "react";
import {
  useCreateRefrigerationDataMutation,
  useGetPackingSummaryQuery,
  useUpdateRefrigerationDataMutation,
} from "../packing/packingApi";
import { RefreshSvg } from "../../../svgFiles/RefreshSvg";
import { Col, Row } from "react-bootstrap";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import { useGetFruitsQuery } from "../../Receiving/unloading/unloadingApi";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import { getCurrentTime } from "../../../components/shared/utils";
import toast from "react-hot-toast";
import useTranslator from "../../../hooks/useTranslator";
import { useGetPalletsQuery } from "../../../app/globalApi";
import { getCurrentDate } from "../../../helpers/Utils";


const RefrigerationModal = ({ show, setShow, record, mode, lot_number_id }) => {
  const { _t } = useTranslator();
  const [createData, { isLoading: isCreating }] =
    useCreateRefrigerationDataMutation();
  const [updateData, { isLoading: isUpdating }] =
    useUpdateRefrigerationDataMutation();
  const currentDate = getCurrentDate("YYYY-MM-DD");  
  const { data: summaryData } = useGetPackingSummaryQuery({
    tab: "refrigeration",
    date: currentDate,
  });
  const { data: pallets, refetch: refetchPallets } = useGetPalletsQuery();
    
  const maxBox = summaryData?.boxes_on_floor;

  const maxCheeks10Pounds = summaryData?.total_refrigration_prime_cheek_boxes_10_pound;
  const maxCheeks20Pounds = summaryData?.total_refrigration_prime_cheek_boxes_20_pound;
  const maxStrips10Pounds = summaryData?.total_refrigration_prime_strip_boxes_10_pound;
  const maxStrips20Pounds = summaryData?.total_refrigration_prime_strip_boxes_20_pound;

  const [localPallets, setLocalPallets] = useState([]);
  
  
  const initialFormData = {
    status: "",
    type: "",
    created_at: currentDate,
    pallet_number: "",
    time_entered: getCurrentTime(),
    fruit_type_id: "",
    number_of_box: "",
    cheeks_kg: "",
    strips_kg: "",
    strips_boxes : "",
    cheeks_boxes : "",
    prime_lite_cheeks_boxes : "",
    prime_lite_strips_boxes : "",
    lot_number_id: lot_number_id,
    prime_cheek_boxes_10_pound : "",
    prime_cheek_boxes_20_pound : "",
    prime_strip_boxes_10_pound : 0,
    prime_strip_boxes_20_pound : ""
  };
  const [formData, setFormData] = useState(initialFormData);


  // :::::::::: Pallet Config ::::::::::::

  useEffect(() => {
    if (pallets) {
      setLocalPallets([...pallets?.data]);
    }
  }, [pallets]);

   

  const isPalletAvailable = (pallet) => {
    const alreadySelected = (formData.receiving_pallets || []).some(
      (p) => p.pallet_id == pallet.id
    );

    return !alreadySelected;
  };

    
  //  const addPalletHandler = () => {
  //     if (!selectedPalletId) {
  //       toast.error(messages.selectPallet);
  //       return;
  //     }
  
  //     const kg = parseFloat(selectedPalletTotalKg);
  //     if (isNaN(kg)) {
  //       toast.error(messages.validKg);
  //       return;
  //     }
  
  //     const cases = parseInt(selectedPalletTotalCases);
  //     if (isNaN(cases) || cases <= 0 || cases > PALLET_GREEN_CASES) {
  //       toast.error(messages.validCases);
  //       return;
  //     }
  
  //     // Weight-related validations
  //     if (kg < palletTotalMinWeight && kg > 0) {
  //       const hasNonPalletizeCase = formData?.receiving_pallets?.some(
  //         (p) => parseFloat(p.pallet_kg_entered) < 30 * formData?.case_fresh
  //       );
  //       if (hasNonPalletizeCase) {
  //         toast.error(
  //           `${messages.onlyOneLowWeight} ${palletTotalMinWeight} ${messages.isAllowed}. ${messages.deleteExisting}`
  //         );
  //         return;
  //       }
  //     } else if (kg < palletTotalMinWeight || kg > palletTotalMaxWeight) {
  //       toast.error(
  //         `${messages.kgBetween} ${palletTotalMinWeight} ${messages.and} ${palletTotalMaxWeight}`
  //       );
  //       return;
  //     }
  
  //     // validate weight against cases
  //     const minExpectedKg = ceilToTwoDecimal(
  //       cases * parseInt(formData?.case_fresh) +
  //         cases * EMPTY_GREEN_CASE_WEIGHT +
  //         EMPTY_PALLET_WEIGHT
  //     );
  
  //     const maxExpectedKg = ceilToTwoDecimal(minExpectedKg + 190);
  
  //     if (cases == PALLET_GREEN_CASES || kg >= palletTotalMinWeight) {
  //       if (kg < minExpectedKg || kg > maxExpectedKg) {
  //         toast.error(
  //           `${messages.kgBetween} ${minExpectedKg} ${messages.and} ${maxExpectedKg}`
  //         );
  //         return;
  //       }
  //     }
  
  //     const newPallet = calculateNewPallet(kg, cases);
  
  //     if (!newPallet) {
  //       toast.error(messages.kgTooLow);
  //       return;
  //     }
  
  //     newPallet.pallet_id = selectedPalletId;
  
  //     if (newPallet.pallet_type === "non_palletize") {
  //       setNonPalletizedPallet(newPallet);
  //     }
  
  //     setFormData((prev) => ({
  //       ...prev,
  //       receiving_pallets: [...prev.receiving_pallets, newPallet],
  //     }));
  
  //     setSelectedPalletId("");
  //     setSelectedPalletTotalKg("");
  //     setSelectedPalletTotalCases("");
  //   };
  

  // ::::::::: END ::::::::::::

  const formatTime = (time) => (time ? time.slice(0, 5) : "");
  // useEffect(() => {
  //   if (lotNumber?.data) {
  //     setFormData((prevFormData) => ({
  //       ...prevFormData,
  //       lot_number_id: lotNumber.data,
  //     }));
  //   }
  // }, [lotNumber]);
  useEffect(() => {

    if (mode === "edit" && record) {
      // console.log(record);
      const updatedFormData = { ...initialFormData };

      for (const key in record) {
        if (key in initialFormData) updatedFormData[key] = record[key];
      }

      updatedFormData.created_at = record.created_at
        ? record.created_at.split(" ")[0]
        : currentDate;
      updatedFormData.time_entered = formatTime(record.time_entered);
      setFormData(updatedFormData);
    } else {
      setFormData(initialFormData);
    }
  }, [mode, record, show]);
  const handleClose = () => {
    setShow(false);
  };
  const { data: fruitList } = useGetFruitsQuery();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormData(formData);
    const cheek_boxes_10 = parseInt(formData.prime_cheek_boxes_10_pound) || 0;
    const cheek_boxes_20 = parseInt(formData.prime_cheek_boxes_20_pound) || 0;
    const strip_boxes_10 = parseInt(formData.prime_strip_boxes_10_pound) || 0;
    const strip_boxes_20 = parseInt(formData.prime_strip_boxes_20_pound) || 0;

    const totalBoxes = cheek_boxes_10 + cheek_boxes_20 + strip_boxes_10 + strip_boxes_20;
    if (mode === "add" && maxBox !== undefined && totalBoxes > maxBox) {
      toast.error(_t("box_number_exceeds_total", `Box number exceeds the total available boxes (${maxBox}). Please enter a valid amount.`));
      return;
    }

    // In 'add' mode — individual limits for cheeks and strips
    if (mode === "add") {
      // if (maxCheeks !== undefined && cheeks > maxCheeks) {
      //   toast.error(`Cheek boxes exceed the allowed total (${maxCheeks})!`);
      //   return;
      // }
      // if (maxStrips !== undefined && strips > maxStrips) {
      //   toast.error(`Strip boxes exceed the allowed total (${maxStrips})!`);
      //   return;
      // }
      // if (maxPirmeCheeks !== undefined && cheeksPrime > maxPirmeCheeks) {
      //   toast.error(
      //     `Strip boxes exceed the allowed total (${maxPirmeCheeks})!`
      //   );
      //   return;
      // }
      // if (maxPirmeStrips !== undefined && stripsPrime > maxPirmeStrips) {
      //   toast.error(
      //     `Strip boxes exceed the allowed total (${maxPirmeStrips})!`
      //   );
      //   return;
      // }
    }

    // In 'edit' mode — check against difference
    if (mode === "edit" && maxBox !== undefined) {
      const existingTotal =
        (parseInt(record.prime_cheek_boxes_10_pound) || 0) +
        (parseInt(record.prime_cheek_boxes_20_pound) || 0) +
        (parseInt(record.prime_strip_boxes_10_pound) || 0) +
        (parseInt(record.prime_strip_boxes_20_pound) || 0);

      const allowedTotal = maxBox + existingTotal;

      if (totalBoxes > allowedTotal) {
        toast.error(
          `Box number exceeds the allowed boxes (${allowedTotal}) for this floor!`
        );
        return;
      }

      // Also check individual differences for cheeks and strips in edit mode
      // const allowedCheeks =
      //   (maxCheeks || 0) + (parseInt(record.prime_cheek_boxes_10_pound) || 0);
      // const allowedStrips =
      //   (maxStrips || 0) + (parseInt(record.prime_cheek_boxes_20_pound) || 0);
      // const allowedStripsPrime =
      //   (maxStrips || 0) + (parseInt(record.prime_strip_boxes_10_pound) || 0);
      // const allowedCheeksPrime =
      //   (maxStrips || 0) + (parseInt(record.prime_strip_boxes_20_pound) || 0);

      // if (cheeks > allowedCheeks) {
      //   toast.error(`Cheek boxes exceed the allowed total (${allowedCheeks})!`);
      //   return;
      // }

      // if (strips > allowedStrips) {
      //   toast.error(`Strip boxes exceed the allowed total (${allowedStrips})!`);
      //   return;
      // }
      // if (stripsPrime > allowedStripsPrime) {
      //   toast.error(
      //     `Strip boxes exceed the allowed total (${allowedStripsPrime})!`
      //   );
      //   return;
      // }
      // if (cheeksPrime > allowedCheeksPrime) {
      //   toast.error(
      //     `Strip boxes exceed the allowed total (${allowedCheeksPrime})!`
      //   );
      //   return;
      // }
    }
    const mutation = mode === "add" ? createData : updateData;

    try {
      const payload =
        mode === "add" ? formData : { id: record.id, requestBody: formData };
      await mutation(payload).unwrap();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: value,
      };
      const cheek_boxes_10 = parseInt(updatedFormData.prime_cheek_boxes_10_pound) || 0;
      const cheek_boxes_20 = parseInt(updatedFormData.prime_cheek_boxes_20_pound) || 0;
      const strip_boxes_10 = parseInt(updatedFormData.prime_strip_boxes_10_pound) || 0;
      const strip_boxes_20 = parseInt(updatedFormData.prime_strip_boxes_20_pound) || 0;

      if (
        name === "prime_cheek_boxes_10_pound" ||
        name === "prime_cheek_boxes_20_pound" ||
        name === "prime_strip_boxes_10_pound" ||
        name === "prime_strip_boxes_20_pound"
      ) {
        updatedFormData.number_of_box =
          cheek_boxes_10 + cheek_boxes_20 + strip_boxes_10 + strip_boxes_20;
      }

      return updatedFormData;
    });
  };

  // console.log(formData)
  const renderFormFields = () => (
    <>
      <Col lg={12}>
        <Col lg={6}>
          <InputWithLabel
            label={_t("packing_batch_code", "Packing Batch Code")}
            type="text"
            name="lot_number_id"
            value={formData.lot_number_id}
            disabled={true}
            onChange={handleChange}
          />
        </Col>
        {/* <Col lg={6}>
          <InputWithLabel
            label={_t("refrigeration_modal_time", "Time Entered")}
            type="datetime-local"
            name="time_entered"
            value={formData.time_entered}
            onChange={handleChange}
            disabled={true}
          />
        </Col> */}
      </Col>
      {/* <Col lg={6}>
        <InputWithLabel
          label={_t("refrigeration_modal_date", "Date")}
          type="text"
          name="created_at"
          value={formData.created_at}
          disabled={true}
          onChange={handleChange}
        />
      </Col>
      <Col lg={6}>
        <InputWithLabel
          label={_t("refrigeration_modal_time", "Time Entered")}
          type="time"
          name="time_entered"
          value={formData.time_entered}
          onChange={handleChange}
          disabled={true}
        />
      </Col> */}
      {/* <Col lg={6}>
        <InputWithLabel
          label={_t("refrigeration_modal_pallet", "Pallet Number")}
          type="text"
          name="pallet_number"
          value={formData.pallet_number}
          onChange={handleChange}
          placeholder={_t(
            "refrigeration_modal_pallet_placeholder",
            "PLT-00000"
          )}
        />
      </Col> */}
      <Col lg={6}>
        <SelectBox 
          label={_t("select_pallet", "Select Pallet")}
          name="pallet_number"
          options={localPallets.map((list) => ({
            value: list.id,
            label: list.pallet_name,
            // disabled: !isPalletAvailable(list),
          }))}
          value={formData.pallet_number}
          required={false}
          onChange={handleChange}
          className="w-100"
        />
      </Col>

      <Col lg={6}>
        <SelectBox
          label={_t("refrigeration_modal_fruit", "Fruit Type")}
          type="text"
          name="fruit_type_id"
          value={formData.fruit_type_id}
          options={fruitList?.data.map((list) => ({
            value: list.id,
            label: _t(list.name, list.name),
          }))}
          onChange={handleChange}
        />
      </Col>

      {/* ::::::::: Boxes type ::::::::: */}

      <Col lg={12}>
        <Row>
          <Col lg={6}>
            <InputWithLabel
              label={_t("prime_cheek_boxes_10_pund", "Prime Cheek Boxes (10 pounds)")}
              type="number"
              name="prime_cheek_boxes_10_pound"
              value={formData.prime_cheek_boxes_10_pound}
              onChange={handleChange}
              icon={RefreshSvg}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("prime_cheek_boxes_20_pund", "Prime Cheek Boxes (20 pounds)")}
              type="number"
              name="prime_cheek_boxes_20_pound"
              value={formData.prime_cheek_boxes_20_pound}
              onChange={handleChange}              
              icon={RefreshSvg}
              placeholder={"0"}
            />
          </Col>
        </Row>
      </Col>
      <Col lg={12}>
        <Row>
          {/* <Col lg={6}>
            <InputWithLabel
              label={_t(
                "prime_strip_boxes_10_pund",
                "Prime Strip Boxes (10 pounds)"
              )}
              type="number"
              name="prime_strip_boxes_10_pound"
              value={formData.prime_strip_boxes_10_pound}
              onChange={handleChange}
              icon={RefreshSvg}
              placeholder={"0"}
            />
          </Col> */}
          <Col lg={6}>
            <InputWithLabel
              label={_t(
                "prime_strip_boxes_20_pund",
                "Prime Strip Boxes (20 pounds)"
              )}
              type="number"
              name="prime_strip_boxes_20_pound"
              value={formData.prime_strip_boxes_20_pound}
              onChange={handleChange}
              icon={RefreshSvg}
              placeholder={"0"}
            />
          </Col>
          <Col lg={6}>
            <InputWithLabel
              label={_t("refrigeration_modal_total_boxes", "Total Number of Boxes")}
              type="number"
              name="number_of_box"
              value={formData.number_of_box}
              disabled={false}
              onChange={handleChange}
              placeholder={"0"}
            />
          </Col>
        </Row>
      </Col>

      {/* :::::::::::: END :::::::::: */}

      
      <Col lg={6}>
        <SelectBox
          label={_t("refrigeration_modal_status", "Status")}
          type="text"
          name="status"
          value={formData?.status}
          options={[
            {
              value: "stored",
              label: _t("refrigeration_status_stored", "Stored"),
            },
            { value: "sold", label: _t("refrigeration_status_sold", "Sold") },
          ]}
          onChange={handleChange}
        />
      </Col>
      
    </>
  );
  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "add"
          ? _t(
              "refrigeration_modal_add_title",
              "Adding Refrigeration Room Data"
            )
          : _t(
              "refrigeration_modal_edit_title",
              "Editing Refrigeration Room Data"
            )
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          <Button
            label={_t("refrigeration_modal_save", "Save Changes")}
            size="small"
            onClick={handleSubmit}
            disabled={isCreating || isUpdating}
          />
        </Col>
      </Row>
    </CommonModal>
  );
};

export default RefrigerationModal;
